(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9540],{

/***/ 42842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ Checkbox; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32808);
/* harmony import */ var _field__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31690);




const Checkbox = (_a) => {
    var { name, validate, fast, onChange } = _a, restProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__rest)(_a, ["name", "validate", "fast", "onChange"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_field__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { name: name, validate: validate, fast: fast }, ({ field: { value }, form: { setFieldValue, setFieldTouched }, }) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, Object.assign({ name: name, id: name, checked: value, onChange: (event) => {
            setFieldValue(name, event.target.checked);
            setFieldTouched(name, true, false);
            onChange && onChange(event);
        } }, restProps)))));
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Checkbox)));
Checkbox.Group = (_a) => {
    var { name, validate, onChange } = _a, restProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__rest)(_a, ["name", "validate", "onChange"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_field__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { name: name, validate: validate }, ({ field: { value }, form: { setFieldValue, setFieldTouched }, }) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Group */ .Z.Group, Object.assign({ value: value, onChange: (value) => {
            setFieldValue(name, value);
            setFieldTouched(name, true, false);
            onChange && onChange(value);
        } }, restProps)))));
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 31690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Field */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82580);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



const Field = (_a) => {
    var { fast, children } = _a, restProps = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__rest)(_a, ["fast", "children"]);
    if (fast) {
        return react__WEBPACK_IMPORTED_MODULE_1__.createElement(formik__WEBPACK_IMPORTED_MODULE_0__/* .FastField */ .Rt, Object.assign({}, restProps), children);
    }
    return react__WEBPACK_IMPORTED_MODULE_1__.createElement(formik__WEBPACK_IMPORTED_MODULE_0__/* .Field */ .gN, Object.assign({}, restProps), children);
};
/* harmony default export */ __webpack_exports__["Z"] = (Field);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 14271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Form; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82580);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8289);
/* harmony import */ var _form_item__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29553);




function Form(props) {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(formik__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, null, ({ form: { handleReset, handleSubmit } }) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, Object.assign({ onReset: handleReset, onFinish: handleSubmit }, props)))));
}
Form.Item = _form_item__WEBPACK_IMPORTED_MODULE_3__/* .FormItem */ .x;
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Form)));
//# sourceMappingURL=form.js.map

/***/ }),

/***/ 96127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ TypedInput; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70655);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79531);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _field__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31690);




const Input = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
    var { name, validate, fast, onChange: $onChange, onBlur: $onBlur } = _a, restProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__rest)(_a, ["name", "validate", "fast", "onChange", "onBlur"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_field__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { name: name, validate: validate, fast: fast }, ({ field: { value, onChange, onBlur } }) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, Object.assign({ ref: ref, name: name, id: name, value: value, onChange: (event) => {
            onChange(event);
            $onChange && $onChange(event);
        }, onBlur: (event) => {
            onBlur(event);
            $onBlur && $onBlur(event);
        } }, restProps)))));
});
const TypedInput = Input;
TypedInput.Password = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
    var { name, validate, fast, onChange: $onChange, onBlur: $onBlur } = _a, restProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__rest)(_a, ["name", "validate", "fast", "onChange", "onBlur"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_field__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { name: name, validate: validate, fast: fast }, ({ field: { value, onChange, onBlur } }) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Password */ .Z.Password, Object.assign({ ref: ref, name: name, id: name, value: value, onChange: (event) => {
            onChange(event);
            $onChange && $onChange(event);
        }, onBlur: (event) => {
            onBlur(event);
            $onBlur && $onBlur(event);
        } }, restProps)))));
});
TypedInput.TextArea = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
    var { name, validate, fast, onChange: $onChange, onBlur: $onBlur } = _a, restProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__rest)(_a, ["name", "validate", "fast", "onChange", "onBlur"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_field__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { name: name, validate: validate, fast: fast }, ({ field: { value, onChange, onBlur } }) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].TextArea */ .Z.TextArea, Object.assign({ ref: ref, name: name, id: name, value: value, onChange: (event) => {
            onChange(event);
            $onChange && $onChange(event);
        }, onBlur: (event) => {
            onBlur(event);
            $onBlur && $onBlur(event);
        } }, restProps)))));
});

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (TypedInput)));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 76453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ Select; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70655);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18963);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _field__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31690);




// declare class Select<ValueType extends SelectValue = SelectValue> extends React.Component<SelectProps<ValueType>> {
const Select = (_a) => {
    var { name, validate, fast, children, onChange, onBlur } = _a, restProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__rest)(_a, ["name", "validate", "fast", "children", "onChange", "onBlur"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_field__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { name: name, validate: validate, fast: fast }, ({ field: { value }, form: { setFieldValue, setFieldTouched }, }) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, Object.assign({ onChange: (value, option) => {
            setFieldValue(name, value);
            onChange && onChange(value, option);
        }, onBlur: (value) => {
            setFieldTouched(name);
            onBlur && onBlur(value);
        }, 
        // setting undefined will show the placeholder
        value: value === '' || value === null ? undefined : value, id: name }, restProps), children))));
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Select)));
Select.Option = antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Option */ .Z.Option;
Select.OptGroup = antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].OptGroup */ .Z.OptGroup;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 481:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us/cooperation",
      function () {
        return __webpack_require__(85080);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 85080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/ramda/es/index.js + 227 modules
var es = __webpack_require__(36486);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 12 modules
var esm = __webpack_require__(10686);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/formik-antd/es/input/index.js
var input = __webpack_require__(96127);
// EXTERNAL MODULE: ./node_modules/formik-antd/es/select/index.js
var es_select = __webpack_require__(76453);
// EXTERNAL MODULE: ./packages/datasource/src/api/contactUs/index.js
var contactUs = __webpack_require__(77169);
// EXTERNAL MODULE: ./src/pages/contact-us/commonForm/index.js + 1 modules
var commonForm = __webpack_require__(51844);
// EXTERNAL MODULE: ./src/components/index.js + 20 modules
var components = __webpack_require__(21679);
// EXTERNAL MODULE: ./src/pages/contact-us/commonForm/commonForm.fields.js
var commonForm_fields = __webpack_require__(14720);
;// CONCATENATED MODULE: ./src/pages/contact-us/cooperation/form/form.fields.js

var getFields = function(param) {
    var lang = param.lang, t = param.t;
    var typeLang = lang.type;
    var dropdownValidator = (0,commonForm_fields/* getDropdownValidator */.Q9)({
        lang: lang
    });
    var textareaValidator = (0,commonForm_fields/* getTextareaValidator */.V5)({
        lang: lang,
        t: t,
        limit: 300
    });
    return {
        type: {
            name: "cooperation_type",
            placeholder: lang.pleaseSelect,
            options: [
                {
                    value: "technology",
                    label: typeLang.technology
                },
                {
                    value: "community",
                    label: typeLang.community
                },
                {
                    value: "other",
                    label: typeLang.other
                }, 
            ],
            validator: dropdownValidator
        },
        detail: {
            name: "detail",
            placeholder: lang.detail.placeholder,
            rows: 8,
            validator: textareaValidator
        }
    };
};

;// CONCATENATED MODULE: ./src/pages/contact-us/cooperation/form/Form.component.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var TextArea = input/* Input.TextArea */.I.TextArea;
var FormComponent = function() {
    var t = (0,esm/* useTranslation */.$G)("page-contact-us", "common").t;
    var formLocalePath = "cooperation.form";
    var lang = _objectSpread({}, t(formLocalePath, {
        returnObjects: true
    }), t("common:form", {
        returnObjects: true
    }));
    var formFields = getFields({
        lang: lang,
        t: t
    });
    var type = formFields.type, detail = formFields.detail;
    var commonFormProps = {
        formFields: formFields,
        formLocalePath: formLocalePath,
        submitApi: contactUs.requestCooperation
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(commonForm/* default */.Z, _objectSpread({}, commonFormProps, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                span: 24,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RequiredFormItem */.Xz, {
                    label: lang.type.label,
                    name: type.name,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* Select */.P, _objectSpread({}, type))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                span: 24,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RequiredFormItem */.Xz, {
                    label: lang.detail.label,
                    name: detail.name,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea, _objectSpread({}, detail))
                })
            })
        ]
    }));
};
/* harmony default export */ var Form_component = (FormComponent);

;// CONCATENATED MODULE: ./src/pages/contact-us/cooperation/form/index.js


// EXTERNAL MODULE: ./src/pages/contact-us/layout/index.js + 3 modules
var layout = __webpack_require__(64174);
;// CONCATENATED MODULE: ./src/pages/contact-us/cooperation/index.page.js
function index_page_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function index_page_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            index_page_defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var Page = function() {
    var t = (0,esm/* useTranslation */.$G)("page-contact-us").t;
    var lang = t("cooperation", {
        returnObjects: true
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CommunityHead */.Wh, {
                title: lang.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* default */.Z, index_page_objectSpread({}, es/* pick */.eiS([
                "title",
                "subtitle"
            ], lang), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_component, {})
            }))
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var index_page = (Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8042,8648,9774,2888,179], function() { return __webpack_exec__(481); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);